/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  Account,
  DiscoveryRule,
  DiscoveryRuleMatch,
} from "~/generated/graphql";

export enum RuleType {
  CLOUD_ACCOUNT = "cloudAccount",
  RESOURCE_GROUP = "resourceGroup",
  IBM_RESOURCE_GROUP = "ibmResourceGroup",
  PROJECT_ID = "projectId",
  RESOURCE_TYPE = "type",
  RESOURCE_TAGS = "tags",
  AWS_VPC = "subnetIds",
  SECURITY_GROUP_IDS = "securityGroupIds",
}

export type SelectorOption = {
  label: string;
  value: string;
  icon?: boolean;
};

export type SelectInputOption = {
  label: string;
  value: RuleType;
};

export type DiscoveryRuleMatchInput = Omit<DiscoveryRuleMatch, "__typename">;

export type DiscoveryRuleMatchKeys = keyof DiscoveryRuleMatchInput;

export type DiscoveryRuleInput = {
  exclusive?: boolean;
  ibmResourceGroup?: boolean;
  match?: DiscoveryRule["match"];
};

export type AccountData = Pick<
  Account,
  | "activated"
  | "displayName"
  | "id"
  | "name"
  | "provider"
  | "providerId"
  | "providerType"
> & {
  __typename?: "Account";
};
